import { render, staticRenderFns } from "./HistoryTab.vue?vue&type=template&id=c1cf86b0&scoped=true"
import script from "./HistoryTab.component.js?vue&type=script&lang=js&external"
export * from "./HistoryTab.component.js?vue&type=script&lang=js&external"
import style0 from "./HistoryTab.vue?vue&type=style&index=0&id=c1cf86b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cf86b0",
  null
  
)

export default component.exports